
// import React, { useState, useEffect } from 'react';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import ReactPaginate from 'react-paginate';

// import {
//     Card,
//     Row,
//     Col,
//     CardTitle,
//     CardBody,
//     Button,
//     Form,
//     FormGroup,
//     Label,
//     Input,
//     FormText,
//     Table
// } from "reactstrap";
// import { useSelector } from 'react-redux';


// const BranchMaster = () => {

//     //----------- REDUCE TOOLKIT -------
//     const vendorState = useSelector((state) => state.vendorState);
//     const branchState = useSelector((state) => state.branchState);
//     const { user } = useSelector((state) => state.authState);



//     const navigate = useNavigate();
//     const [branchMaster, setBranchMasterTable] = useState([]);
//     const [totalPage, setTotalPage] = useState();

//     const onHandleSearchKeyItem = (e) => {
//         const value = e.target.value;
//         getBranchMasterData(1, 10, value)
//     }

//     const onHandleAddBranchMaster = () => {
//         navigate("/addbranch")
//     }

//     const onHandleEditBranchMaster = (id) => {
//         let findArrayData = branchMaster.find(e => e.id === id)
//         navigate('/addbranch', { state: { hotelId: findArrayData?.id } });
//     }

//     const getBranchMasterData = async (page = 1, limit = 10, search = "", venderMstId) => {
//         try {
//             let config = {
//                 headers: {
//                     'Content-Type': 'application/json', // Important for file upload//s
//                     'accept': 'application/json'
//                 }
//             };

//             // Build query string
//             let queryParams = `/api/BranchMaster/all?pageNo=${page}&limit=${limit}&searchKey=${search}`;
//             const vendorIdToUse = venderMstId || selectedVendorId;
//             if (vendorIdToUse) {
//                 queryParams += `&venderMasterId=${vendorIdToUse}`;
//             }

//             if (selectedBranchId && !venderMstId) {
//                 queryParams += `&branchMasterId=${selectedBranchId}`; // fixed var name
//             }
//             const response = await apiService.get(queryParams, config);


//             // const response = await apiService.get(`api/BranchMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`, config)
//             if (response.response && response.response.data.errors) {
//                 toast.error(response.response?.data?.errors);
//             }

//             if (response.status === true) {
//                 // console.log(response.BranchMasterMasterData)
//                 setBranchMasterTable(response.branchMasterData)
//                 // toast.success(response.message);
//             }
//             else {
//                 toast.success(response.message);
//             }
//         } catch (error) {
//             console.log(error)
//             toast.error(`SomeThing went wrong!!`);
//         }
//     };

//     useEffect(() => {
//         getBranchMasterData();
//     }, [!branchMaster]);

//     const handlePageClick = (data) => {
//         getBranchMasterData(data.selected + 1)
//     };

//     const onHandleDeleteBranchMaster = async (id) => {

//         const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
//         if (isDeleteConfirmed) {
//             try {
//                 let config = {
//                     headers: {
//                         'Content-Type': 'application/json', // Important for file upload//s
//                         'accept': 'application/json'
//                     }
//                 };

//                 const response = await apiService.delete(`api/BranchMaster/delete?hotelId=${id}`, config)
//                 if (response.response && response.response.data.errors) {
//                     toast.error(response.response?.data?.errors);
//                 }

//                 if (response.status === true) {
//                     toast.success(response.message);
//                     getBranchMasterData()
//                 }
//                 else {
//                     toast.success(response.message);
//                 }
//             } catch (error) {
//                 console.log(error)
//                 toast.error(`SomeThing went wrong!!`);
//             }
//         } else {
//             console.log('Deletion canceled.');
//         }
//     };


//     // =======================  VENDER & BRANCH =================

//     const [selectedVendorId, setSelectedVendorId] = useState("");
//     const [selectedBranchId, setSelectedBranchId] = useState("");

//     // Handle vendor selection change
//     const selectVendorFilter = (e) => {

//         let value = e.target.value
//         if (!value) {
//             setSelectedVendorId(value);
//             setSelectedBranchId("");
//         } else {
//             setSelectedVendorId(value);
//             setSelectedBranchId("");
//             getBranchMasterData(1, 10, "", value)
//         }
//     };


//     // Handle branch selection change
//     const selectbranchFilter = (e) => {
//         setSelectedBranchId(e.target.value);
//     };

//     useEffect(() => {

//         if (user.user_profile != "superadmin" && selectedVendorId && selectedBranchId) {
//             getBranchMasterData(1, 10, "")
//         } else if (user.user_profile === "superadmin") {
//             getBranchMasterData(1, 10, "")
//         }

//         if (vendorState.vendors.length === 1) {
//             setSelectedVendorId(vendorState.vendors[0].id);
//         }

//         if (branchState.branches.length === 1) {
//             setSelectedBranchId(branchState.branches[0].id);
//         }
//     }, [selectedVendorId, selectedBranchId])



//     return (
//         <>
//             <Col lg="12">
//                 <Card className='bg-white pd-10 card-box mb-30'>
//                     <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between sticky-top">
//                         {/* <div className="d-flex align-items-center">
//                             <i className="bi bi-card-text mr-2"></i>
//                             Branch Master
//                         </div> */}

//                         {/* <Row className="align-items-center" style={{ marginRight: '10px', width: '300px' }}>
//                             <Input  id="search" name="search" placeholder="Search..." type="text" onChange={(e) => { onHandleSearchKeyItem(e) }} />
//                         </Row> */}

//                         {/* <Button color="primary" size="bg" onClick={onHandleAddBranchMaster}>Add</Button> */}

//                         <Col>
//                             <Row className="align-items-center  g-0 mb-2">
//                                 <Col xs={12} className="d-flex justify-content-between align-items-center">
//                                     {/* Title aligned left */}
//                                     <div className="d-flex align-items-center">
//                                         <i className="bi bi-card-text mr-2"></i>
//                                         Branch Master
//                                     </div>
//                                     <div className="d-flex justify-content-end mb-2">
//                                         <Button color="success" onClick={onHandleAddBranchMaster} className="d-flex align-items-center">
//                                             <i className="bi bi-plus-circle mr-2"></i>
//                                             New
//                                         </Button>
//                                     </div>

//                                 </Col>
//                             </Row>

//                             <Row style={{ display: "flex", justifyContent: "start" }}>
//                                 <Col xl={12} md={6} className="d-flex justify-content-center justify-content-md-end align-items-center gap-2">
//                                     <Input
                                        
//                                         id="search"
//                                         name="search"
//                                         placeholder="Search..."
//                                         type="text"
//                                         // style={{ minWidth: '250px' }}
//                                         onChange={(e) => onHandleSearchKeyItem(e)}
//                                     />
//                                 </Col>
//                             </Row>

//                             <Row style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
//                                 {/* Vendor Filter */}
//                                 {(vendorState?.vendors.length === 0 || vendorState?.vendors.length > 1) && (
//                                     <Col xl={3} md={4} sm={6} style={{ marginBottom: "15px" }}>
//                                         <FormGroup>
//                                             <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Vendor</label>
//                                             <Input
//                                                 style={{
//                                                     border: "1px solid #ced4da",
//                                                     borderRadius: "4px",
//                                                     padding: "6px 12px",
//                                                 }}
//                                                 type="select"  className="custom-select"
//                                                 name="selectedVendorId"
//                                                 value={selectedVendorId}
//                                                 onChange={selectVendorFilter}
//                                             >
//                                                 <option value="">-- Select Vendor --</option>
//                                                 {vendorState?.vendors.map((data) => (
//                                                     <option key={data.id} value={data.id}>
//                                                         {data.vender_name}
//                                                     </option>
//                                                 ))}
//                                             </Input>
//                                         </FormGroup>
//                                     </Col>
//                                 )}

//                                 {/* Branch Filter */}
//                                 {(branchState?.branches?.length === 0 ||
//                                     branchState?.branches?.length > 1
//                                 ) && (
//                                         <Col xl={3} md={4} sm={6} style={{ marginBottom: "15px" }}>
//                                             <FormGroup>
//                                                 <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Branch</label>
//                                                 <Input
//                                                     style={{
//                                                         border: "1px solid #ced4da",
//                                                         borderRadius: "4px",
//                                                         padding: "6px 12px",
//                                                     }}
//                                                     type="select"  className="custom-select"
//                                                     name="selectedBranchId"
//                                                     value={selectedBranchId}
//                                                     onChange={selectbranchFilter}
//                                                     disabled={!selectedVendorId}
//                                                 >
//                                                     <option value="">-- Select Branch --</option>
//                                                     {branchState?.branches
//                                                         ?.filter((data) =>
//                                                             selectedVendorId
//                                                                 ? String(data.vender_master_id) === String(selectedVendorId)
//                                                                 : true // Show all branches if no vendor is selected
//                                                         )
//                                                         .map((data) => (
//                                                             <option key={data.id} value={data.id}>
//                                                                 {data.branch_name}
//                                                             </option>
//                                                         ))}

//                                                 </Input>
//                                             </FormGroup>
//                                         </Col>
//                                     )}
//                             </Row>
//                         </Col>
//                     </CardTitle>

//                     <CardBody className="">
//                         <Table striped hover responsive>
//                             <thead>
//                                 <tr>
//                                      <th>S. no.</th>
//                                     <th> Company Name</th>
//                                     <th> Branch Name</th>
//                                     <th> Mobile No</th>

//                                     {/* <th>Edit</th> */}
//                                     {/* <th>Delete</th> */}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {branchMaster.map((item, index) => (

//                                     <tr key={index}>
//                                         <th scope='row'>
//                                             <div style={{ display: "flex", alignItems: "center", justifyContent: "start", flexDirection: "column" }}>
//                                                 <span className='ms-2'>{index + 1}</span>

//                                                 <Button
//                                                     color="warning"
//                                                     className="me-0 ms-2"
//                                                     size="sm"
//                                                     onClick={() => onHandleEditBranchMaster(item.id)}
//                                                 >

//                                                     <p style={{ fontSize: 12, padding: 0, margin: 0, fontWeight: "bold" }}><i className="bi bi-pencil mr-1"></i>Edit</p>
//                                                 </Button>

//                                             </div>
//                                         </th>
//                                         {/* <td>{<img style={{ width: 60, height: 60, borderRadius: 100 }} src={API_URL + item.room_image}></img>}</td> */}
//                                         <td>{item?.venderMaster?.vender_name}</td>
//                                         <td>{item.branch_name}</td>
//                                         <td>{item.branch_contact}</td>
//                                         {/* <td>
//                                             <Button color="warning" size="bg" onClick={() => onHandleEditBranchMaster(item.id)}>
//                                                 <i className="bi bi-pencil text-primary" style={{cursor:"pointer"}}></i>
//                                             </Button>
//                                         </td> */}
//                                         {/* <td>
//                                             <Button color="danger" size="bg" onClick={() => onHandleDeleteBranchMaster(item.id)}>
//                                                 <i className="bi bi-trash"></i>
//                                             </Button>
//                                         </td> */}
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </Table>
//                     </CardBody>

//                     <CardBody>
//                         {/* <ReactPaginate
//                             previousLabel={'Previous'}
//                             nextLabel={'Next'}
//                             breakLabel={'...'}
//                             breakClassName={'break-me'}
//                             pageCount={totalPage}
//                             marginPagesDisplayed={2}
//                             pageRangeDisplayed={5}
//                             onPageChange={handlePageClick}
//                             containerClassName={'pagination'}
//                             activeClassName={'active'}
//                         /> */}

//                         <ReactPaginate
//                             previousLabel={'Previous'}
//                             nextLabel={'Next'}
//                             breakLabel={'...'}
//                             pageCount={totalPage} // still 4000
//                             marginPagesDisplayed={1} // 1 page at start & end
//                             pageRangeDisplayed={2}  // visible range around selected page
//                             onPageChange={handlePageClick}
//                             containerClassName={'pagination'}
//                             activeClassName={'active'}

//                             pageClassName={'page-item'}
//                             pageLinkClassName={'page-link'}
//                             previousClassName={'page-item'}
//                             nextClassName={'page-item'}
//                             previousLinkClassName={'page-link'}
//                             nextLinkClassName={'page-link'}
//                             breakClassName={'page-item'}
//                             breakLinkClassName={'page-link'}
//                         />
//                     </CardBody>
//                 </Card>
//             </Col>
//         </>
//     )
// }

// export default BranchMaster

//SignalR
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import ReactPaginate from 'react-paginate';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Input,
  Table,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import {
  createAppConnection,
  joinModuleGroup,
  leaveModuleGroup,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

const MODULE_NAME = 'BranchMaster';

const BranchMaster = () => {
  const vendorState = useSelector((state) => state.vendorState);
  const branchState = useSelector((state) => state.branchState);
  const { user } = useSelector((state) => state.authState);

  const navigate = useNavigate();
  const [branchMaster, setBranchMasterTable] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [searchKey, setSearchKey] = useState('');

  const [selectedVendorId, setSelectedVendorId] = useState('');
  const [selectedBranchId, setSelectedBranchId] = useState('');

  const currentGroupRef = useRef({
    module: null,
    vendorId: null,
    branchId: null,
  });

  const onHandleAddBranchMaster = () => {
    navigate('/addbranch');
  };

  const onHandleEditBranchMaster = (id) => {
    let findArrayData = branchMaster.find((e) => e.id === id);
    navigate('/addbranch', { state: { hotelId: findArrayData?.id } });
  };

  const getBranchMasterData = useCallback(
    async (page = 1, limit = 10, search = '', venderMstId) => {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
        };

        let queryParams = `/api/BranchMaster/all?pageNo=${page}&limit=${limit}&searchKey=${encodeURIComponent(search)}`;
        const vendorIdToUse = venderMstId || selectedVendorId;

        if (vendorIdToUse) {
          queryParams += `&venderMasterId=${vendorIdToUse}`;
        }

        if (selectedBranchId && !venderMstId) {
          queryParams += `&branchMasterId=${selectedBranchId}`;
        }

        const response = await apiService.get(queryParams, config);

        if (response.response && response.response.data?.errors) {
          toast.error(response.response?.data?.errors);
        }

        if (response.status === true) {
          setBranchMasterTable(response.branchMasterData || []);
          setTotalPage(response.totalPages || 0);
        } else {
          setBranchMasterTable([]);
          toast.error(response.message || 'Failed');
        }
      } catch (error) {
        console.log(error);
        toast.error('SomeThing went wrong!!');
        setBranchMasterTable([]);
      }
    },
    [selectedVendorId, selectedBranchId]
  );

  const onHandleSearchKeyItem = (e) => {
    const value = e.target.value;
    setSearchKey(value);
    getBranchMasterData(1, 10, value);
  };

  const handlePageClick = (data) => {
    getBranchMasterData(data.selected + 1, 10, searchKey);
  };

  const onHandleDeleteBranchMaster = async (id) => {
    const isDeleteConfirmed = window.confirm(
      'Are you sure you want to delete this item?'
    );

    if (isDeleteConfirmed) {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
        };

        const response = await apiService.delete(
          `api/BranchMaster/delete?BranchId=${id}`,
          config
        );

        if (response.response && response.response.data?.errors) {
          toast.error(response.response?.data?.errors);
        }

        if (response.status === true) {
          toast.success(response.message || 'Deleted');
          getBranchMasterData(1, 10, searchKey);
        } else {
          toast.error(response.message || 'Delete failed');
        }
      } catch (error) {
        console.log(error);
        toast.error('SomeThing went wrong!!');
      }
    }
  };

  const selectVendorFilter = (e) => {
    let value = e.target.value;
    if (!value) {
      setSelectedVendorId('');
      setSelectedBranchId('');
    } else {
      setSelectedVendorId(value);
      setSelectedBranchId('');
      getBranchMasterData(1, 10, '', value);
    }
  };

  const selectbranchFilter = (e) => {
    setSelectedBranchId(e.target.value);
  };

  useEffect(() => {
    if (vendorState.vendors.length === 1) {
      setSelectedVendorId(vendorState.vendors[0].id);
    }

    if (branchState.branches.length === 1) {
      setSelectedBranchId(branchState.branches[0].id);
    }
  }, [vendorState.vendors, branchState.branches]);

  useEffect(() => {
    if (user.user_profile !== 'superadmin' && selectedVendorId && selectedBranchId) {
      getBranchMasterData(1, 10, searchKey);
    } else if (user.user_profile === 'superadmin') {
      getBranchMasterData(1, 10, searchKey);
    }
  }, [selectedVendorId, selectedBranchId, user.user_profile, searchKey, getBranchMasterData]);

  useEffect(() => {
    let mounted = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        const vendorId = selectedVendorId || 0;
        const prev = currentGroupRef.current;

        if (
          prev.vendorId &&
          String(prev.vendorId) !== String(vendorId)
        ) {
          await leaveModuleGroup(prev.module, prev.vendorId, 0);
        }

        if (vendorId) {
          await joinModuleGroup(MODULE_NAME, vendorId, 0);

          currentGroupRef.current = {
            module: MODULE_NAME,
            vendorId,
            branchId: 0,
          };
        }

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mounted) return;
          if (!payload) return;

          const isSameModule =
            String(payload.module || '') === MODULE_NAME;
          const isSameVendor =
            String(payload.vendorId || '') === String(vendorId || '');

          if (isSameModule && isSameVendor) {
            console.log('BranchMaster realtime update received:', payload);
            getBranchMasterData(1, 10, searchKey);
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    if (selectedVendorId) {
      setupSignalR();
    }

    return () => {
      mounted = false;
    };
  }, [selectedVendorId, searchKey, getBranchMasterData]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();

      const prev = currentGroupRef.current;
      if (prev?.vendorId) {
        leaveModuleGroup(prev.module, prev.vendorId, 0).catch(console.error);
      }
    };
  }, []);

  return (
    <>
      <Col lg='12'>
        <Card className='bg-white pd-10 card-box mb-30'>
          <CardTitle
            tag='h6'
            className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between sticky-top'
          >
            <Col>
              <Row className='align-items-center g-0 mb-2'>
                <Col xs={12} className='d-flex justify-content-between align-items-center'>
                  <div className='d-flex align-items-center'>
                    <i className='bi bi-card-text mr-2'></i>
                    Branch Master
                  </div>
                  <div className='d-flex justify-content-end mb-2'>
                    <Button
                      color='success'
                      onClick={onHandleAddBranchMaster}
                      className='d-flex align-items-center'
                    >
                      <i className='bi bi-plus-circle mr-2'></i>
                      New
                    </Button>
                  </div>
                </Col>
              </Row>

              <Row style={{ display: 'flex', justifyContent: 'start' }}>
                <Col xl={12} md={6} className='d-flex justify-content-center justify-content-md-end align-items-center gap-2'>
                  <Input
                    id='search'
                    name='search'
                    placeholder='Search...'
                    type='text'
                    value={searchKey}
                    onChange={onHandleSearchKeyItem}
                  />
                </Col>
              </Row>

              <Row style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                {(vendorState?.vendors.length === 0 || vendorState?.vendors.length > 1) && (
                  <Col xl={3} md={4} sm={6} style={{ marginBottom: '15px' }}>
                    <FormGroup>
                      <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                        Vendor
                      </label>
                      <Input
                        style={{
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          padding: '6px 12px',
                        }}
                        type='select'
                        className='custom-select'
                        name='selectedVendorId'
                        value={selectedVendorId}
                        onChange={selectVendorFilter}
                      >
                        <option value=''>-- Select Vendor --</option>
                        {vendorState?.vendors.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.vender_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                )}

                {(branchState?.branches?.length === 0 || branchState?.branches?.length > 1) && (
                  <Col xl={3} md={4} sm={6} style={{ marginBottom: '15px' }}>
                    <FormGroup>
                      <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                        Branch
                      </label>
                      <Input
                        style={{
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          padding: '6px 12px',
                        }}
                        type='select'
                        className='custom-select'
                        name='selectedBranchId'
                        value={selectedBranchId}
                        onChange={selectbranchFilter}
                        disabled={!selectedVendorId}
                      >
                        <option value=''>-- Select Branch --</option>
                        {branchState?.branches
                          ?.filter((data) =>
                            selectedVendorId
                              ? String(data.vender_master_id) === String(selectedVendorId)
                              : true
                          )
                          .map((data) => (
                            <option key={data.id} value={data.id}>
                              {data.branch_name}
                            </option>
                          ))}
                      </Input>
                    </FormGroup>
                  </Col>
                )}
              </Row>
            </Col>
          </CardTitle>

          <CardBody>
            <Table striped hover responsive>
              <thead>
                <tr>
                  <th>S. no.</th>
                  <th>Company Name</th>
                  <th>Branch Name</th>
                  <th>Mobile No</th>
                </tr>
              </thead>
              <tbody>
                {branchMaster.length ? (
                  branchMaster.map((item, index) => (
                    <tr key={item.id ?? index}>
                      <th scope='row'>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'start',
                            flexDirection: 'column',
                          }}
                        >
                          <span className='ms-2'>{index + 1}</span>

                          <Button
                            color='warning'
                            className='me-0 ms-2'
                            size='sm'
                            onClick={() => onHandleEditBranchMaster(item.id)}
                          >
                            <p
                              style={{
                                fontSize: 12,
                                padding: 0,
                                margin: 0,
                                fontWeight: 'bold',
                              }}
                            >
                              <i className='bi bi-pencil mr-1'></i>Edit
                            </p>
                          </Button>
                        </div>
                      </th>
                      <td>{item?.venderMaster?.vender_name}</td>
                      <td>{item.branch_name}</td>
                      <td>{item.branch_contact}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} style={{ textAlign: 'center' }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>

          <CardBody>
            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageCount={totalPage}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              activeClassName={'active'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              nextClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextLinkClassName={'page-link'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
            />
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default BranchMaster;